/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import './styles.scss';

export class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };
  }

  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSignin = async () => {
    this.props.clearUserStatuses();
    if (this.state.email && this.state.password) {
      try {
        await this.props.loginUser(this.state.email, this.state.password, this.props.history);
        await this.props.getUserData();
        if (this.props.authenticated) this.props.history.push('/');
      } catch (error) {
        console.log(error);
      }
    }
  }

  render() {
    return (
      <div className="register-container" onKeyPress={(e) => { if (e.key === 'Enter') this.handleSignin(); }}>
        <div className="register-subcontainer">
          <h1 className="register-title">Student Sign In</h1>
          <div className="register-form-section">
            <p className="register-label">Email:</p>
            <input
              className="password-input"
              name="email"
              value={this.state.email}
              onChange={this.handleInputChange}
            />
          </div>
          <div className="register-form-section">
            <p className="register-label">Password:</p>
            <input
              className="password-input"
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.handleInputChange}
            />
          </div>
          {this.props.loginError ? <p className="signup-error-text">There was an error signing you in. Make sure your email and password are correct.</p> : null}
          <button
            className="sign-up-button"
            type="button"
            onClick={this.handleSignin}
            disabled={!this.state.email || !this.state.password}
          >Log In
          </button>
        </div>
      </div>
    );
  }
}

export default Login;
